var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panorama-control"},[_c('panorama-ui-select',{staticStyle:{"z-index":"5"},attrs:{"items":_vm.$panorama.control.categories,"value":_vm.activeCategory},on:{"input":_vm.changeCategory}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }